import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  DestroyRef,
  Input,
  EventEmitter,
  Output,
  NgModule,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { INullifyModalOptionsStyles } from '@shared/interfaces';
import { NullifyModalService } from '@core/services/system/nullify-modal.service';
import { DurationPickerComponent } from '../duration-picker/duration-picker.component';
import { DurationTimePipeModule } from '@shared/pipes';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pos-duration',
  templateUrl: './duration.component.html',
  styleUrls: ['./duration.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DurationComponent implements OnChanges {
  @Input() maxHours = 24;
  @Input() step = 5;
  @Input() value: string;
  @Output() posSetValue = new EventEmitter<string>();
  public readonly valueState = signal<string>(null);
  private popupSubscription: Subscription;

  constructor(
    private nullifyModalService: NullifyModalService,
    private destroyRef: DestroyRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const valueChange = changes.value;
    if (valueChange) {
      this.valueState.set(valueChange.currentValue || null);
    }
  }

  openPopup(event: Event) {
    const target = event.target as HTMLElement;
    const targetRect = target.getBoundingClientRect();
    const height = 175;
    const padding = 10;
    const expectedHeight = window.innerHeight - targetRect.bottom;
    const arrAbove = expectedHeight > height;
    const top = expectedHeight > height ? targetRect.bottom + padding : targetRect.top - height - padding;

    const styles: INullifyModalOptionsStyles = {
      top: `${top}px !important`,
      right: '0',
      left: 'initial !important',
      maxWidth: '100%',
      margin: '0 20px !important',
      padding: '25px !important',
      width: '182px !important',
      height: `${height}px !important`,
      zIndex: 30001,
    };
    const posSetValue = new EventEmitter<string>();
    this.popupSubscription?.unsubscribe();
    this.popupSubscription = posSetValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.value = value;
      this.valueState.set(value);
      this.posSetValue.emit(value);
    });
    const { step, maxHours } = this;
    const value = this.valueState();
    this.nullifyModalService.initModal({
      component: DurationPickerComponent,
      options: { styles, className: 'pos-content-picker', arrAbove },
      inputs: [{ value, step, maxHours, posSetValue }],
    });
  }
}
@NgModule({
  imports: [DurationTimePipeModule],
  declarations: [DurationComponent],
  exports: [DurationComponent],
})
export class DurationComponentModule {}
